// Copyright (c) 2018 Deere & Company

import './index.scss';
import React, {PropTypes} from 'react';
import AmountOfUseModal from './amount-of-use-modal';
import {FormattedMessage} from 'react-intl';
import LabeledString from '../labeled-string';
import MeasurementReading from '@deere/cps-it.warranty-model-factory/lib/measurement-reading';
import PencilIcon from '../pencil-icon';
import Product from '@deere/cps-it.warranty-model-factory/lib/product';
import UpdateAmountOfUseModal from './update-amount-of-use';
import {buildProductUseAmount} from '../../../product/shared/services/product';
import {getIsPinTransferEnabled} from '../../../product/shared/services/get-is-pin-transfer-enabled-aor';

const AmountOfUseWithModal = props =>
    <div className='amount-of-use-with-modal'>
        {props.measurementReadings.length > 0 &&
            <div>
                <div className='amount-of-use'>
                    <LabeledString
                        className='use-amount-last-updated'
                        data={buildProductUseAmount(props.measurementReadings[0].useAmount, props.measurementReadings[0].date)}
                        label='AMOUNT_OF_USE'
                    />
                    {props.measurementReadings.length > 1 &&
                        <span
                            className='open-use-amount-modal-link'
                            onClick={props.onAmountOfUseModalOpen}
                        >
                            <FormattedMessage id='MORE'/>
                        </span>
                    }
                    {props.amountOfUseHistory && props.measurementReadings[0].isEditAllowed && getIsPinTransferEnabled('add-amount-of-use') &&
                    <PencilIcon
                        onEdit={props.onUpdateAmountOfUseModalOpen}
                    />
                    }
                </div>
                <AmountOfUseModal
                    isModalOpen={props.isAmountOfUseModalOpen}
                    measurementReadings={props.measurementReadings}
                    onCloseButtonClick={props.onAmountOfUseModalClose}
                />
                {props.amountOfUseHistory &&
                <UpdateAmountOfUseModal
                    actions={props.actions}
                    amountOfUseHistory={props.amountOfUseHistory}
                    isModalOpen={props.isUpdateAmountOfUseModalOpen}
                    onCloseButtonClick={props.onUpdateAmountOfUseModalClose}
                    product={props.product}
                    updateAmountOfUseMeasurement={props.updateAmountOfUseMeasurement}
                />
                }
            </div>
        }
    </div>;

AmountOfUseWithModal.displayName = 'AmountOfUseWithModal';
AmountOfUseWithModal.propTypes = {
    actions: PropTypes.object,
    amountOfUseHistory: PropTypes.arrayOf(PropTypes.instanceOf(MeasurementReading)),
    isAmountOfUseModalOpen: PropTypes.bool.isRequired,
    isSapUp: PropTypes.bool.isRequired,
    isUpdateAmountOfUseModalOpen: PropTypes.bool,
    measurementReadings: PropTypes.arrayOf(PropTypes.instanceOf(MeasurementReading)).isRequired,
    onAmountOfUseModalClose: PropTypes.func.isRequired,
    onAmountOfUseModalOpen: PropTypes.func.isRequired,
    onUpdateAmountOfUseModalClose: PropTypes.func,
    onUpdateAmountOfUseModalOpen: PropTypes.func,
    product: PropTypes.instanceOf(Product).isRequired,
    updateAmountOfUseMeasurement: PropTypes.instanceOf(MeasurementReading)
};

export default AmountOfUseWithModal;



// WEBPACK FOOTER //
// ./src/shared/components/amount-of-use-with-modal/index.js